import { useEffect, useRef, useState } from "react";

const StarEffect = ({ fromRef, toRef, onEnd }) => {
  const starRef = useRef();
  const [exploding, setExploding] = useState(false);
  const [fragments, setFragments] = useState([]);

  useEffect(() => {
    if (!fromRef.current || !toRef.current || !starRef.current) return;

    const from = fromRef.current.getBoundingClientRect();
    const to = toRef.current.getBoundingClientRect();

    const dx = to.left + to.width / 2 - (from.left + from.width / 2);
    const dy = to.top + to.height / 2 - (from.top + from.height / 2);

    const el = starRef.current;
    el.style.left = `${from.left + from.width / 2}px`;
    el.style.top = `${from.top + from.height / 2}px`;
    el.style.setProperty("--dx", `${dx}px`);
    el.style.setProperty("--dy", `${dy}px`);

    const timer = setTimeout(() => {
      setExploding(true);
      const fragArray = Array.from({ length: 8 }).map((_, i) => ({
        id: i,
        x: to.left + to.width / 2,
        y: to.top + to.height / 2,
        ex: Math.random() * 80 - 40,
        ey: Math.random() * 80 - 40,
      }));
      setFragments(fragArray);
      setTimeout(() => {
        onEnd();
      }, 1000);
    }, 800);

    return () => clearTimeout(timer);
  }, [fromRef, toRef, onEnd]);

  return (
    <>
      {!exploding && (
        <div className="star-fly" ref={starRef}>
          <span className="star-part">🔥</span>
        </div>
      )}
      {exploding &&
        fragments.map((f) => (
          <div
            key={f.id}
            className="star-fragment"
            style={{
              left: `${f.x}px`,
              top: `${f.y}px`,
              "--ex": `${f.ex}px`,
              "--ey": `${f.ey}px`,
            }}
          >
            🔥
          </div>
        ))}
    </>
  );
};

export default StarEffect;
